
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search } from "lucide-react";
import { devLog } from "@/utils/devLog";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Log the 404 error with more detailed context for debugging
    devLog(
      "404 Error: User attempted to access non-existent route:",
      {
        pathname: location.pathname,
        search: location.search,
        state: location.state,
        referrer: document.referrer,
        timestamp: new Date().toISOString()
      }
    );
  }, [location]);

  // Determine if this is a creator profile path (e.g., /username)
  const isCreatorProfilePath = location.pathname.split('/').length === 2 && 
    !location.pathname.startsWith('/dashboard') && 
    !location.pathname.startsWith('/login') &&
    !location.pathname.startsWith('/signup') &&
    !location.pathname.startsWith('/not-found') &&
    !location.pathname.startsWith('/my-learning') &&
    location.pathname !== '/';

  // Determine if this is a course path (e.g., /username/course-slug)
  const isCoursePath = location.pathname.split('/').length === 3 && 
    !location.pathname.startsWith('/dashboard') && 
    !location.pathname.startsWith('/my-learning');

  let errorMessage = "The page you're looking for doesn't exist.";
  let errorDescription = "The page might have been moved, deleted, or might never have existed.";

  if (isCreatorProfilePath) {
    errorMessage = "Creator not found";
    errorDescription = "The creator profile you're looking for doesn't exist or has been removed.";
  } else if (isCoursePath) {
    errorMessage = "Course not found";
    errorDescription = "The course you're looking for doesn't exist, isn't published, or has been removed.";
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center p-6 max-w-md">
        <div className="w-20 h-20 bg-muted/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <Search className="h-10 w-10 text-muted-foreground/60" />
        </div>
        <h1 className="text-4xl font-bold mb-4 text-primary">404</h1>
        <p className="text-2xl font-semibold mb-4">{errorMessage}</p>
        <p className="text-muted-foreground mb-4">
          {errorDescription}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link to="/">
            <Button variant="default" className="w-full sm:w-auto">
              <Home className="mr-2 h-4 w-4" />
              Return to Home
            </Button>
          </Link>
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="w-full sm:w-auto"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
